import { Component, Prop, Vue } from 'vue-property-decorator';
import { SubNavigationItem } from './sub-navigation-item.interface';

@Component
export default class SubNavigation extends Vue {
    @Prop() items!: SubNavigationItem[];
}
